export default __webpack_public_path__ + "static/media/bg_01.f6765a5c.png";